import Lottie from "lottie-react";
import { useEffect, useState } from "react";
import { StoryData } from "../../types";
import ChatBubble from "../ChatBubble/ChatBubble";
import confettiJson from "../../../../appAssets/jsons/confetti.json";
import "./OnBoardingWelcomeRoom.scss";
import apiPaths from "../../../../../api/endpoints";
import { welcomeSign } from "../../../../appAssets";
import { trackEvent } from "../../../../../mixpanel";
import { TrackingEvents } from "../../../../Utilities/analytics";
interface OnBoardingWelcomeRoomProps {
  isOnboardingDone?: boolean;
  storyArrayData: StoryData | null;
  updateState: () => void;
  onBoardingDoodleImg?: string;
}

function OnBoardingWelcomeRoom({
  storyArrayData,
  updateState,
  onBoardingDoodleImg,
}: OnBoardingWelcomeRoomProps) {
  const [objectIndex, setObjectIndex] = useState(0);
  const [conversationIndex, setConversationIndex] = useState(0);
  const [showButton, setShowButton] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);

  const blocks = storyArrayData?.blocks ?? [];
  const firstBlock = blocks[0];
  const bgUrl = firstBlock?.bgImageTab || firstBlock?.bgImage || "";
  const doodleLink = `${apiPaths.CONTENT_BASE_URL}${storyArrayData?.onBoardingDoodle ?? ""}`;

  // Show confetti on mount for 2 seconds
  useEffect(() => {
    setShowConfetti(true);
    const timer = setTimeout(() => setShowConfetti(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  // Conversation advancement — mirrors native timer logic
  useEffect(() => {
    if (!firstBlock?.conversations) return;

    const conversations = firstBlock.conversations;
    const currentConversation = conversations[conversationIndex]?.object || [];
    const isLastConversation = conversationIndex === conversations.length - 1;
    const isLastObject = objectIndex === currentConversation.length - 1;

    if (objectIndex < currentConversation.length - 1) {
      const delay =
        parseInt(currentConversation[objectIndex]?.duration || "5000", 10) +
        1000;
      const timer = setTimeout(() => setObjectIndex((prev) => prev + 1), delay);
      return () => clearTimeout(timer);
    }

    if (!isLastConversation) {
      const delay =
        parseInt(currentConversation[objectIndex]?.duration || "5000", 10) +
        1000;
      const timer = setTimeout(() => {
        setObjectIndex(0);
        setConversationIndex((prev) => prev + 1);
      }, delay);
      return () => clearTimeout(timer);
    }

    if (isLastConversation && isLastObject) {
      const hasButtonAction = firstBlock?.userActions?.some(
        (a) => a.component === "block.button-input",
      );
      if (hasButtonAction) setShowButton(true);
    }
  }, [conversationIndex, objectIndex, firstBlock]);

  const currentObject =
    firstBlock?.conversations?.[conversationIndex]?.object?.[objectIndex] ??
    null;

  const handleButtonPress = () => {
    trackEvent(TrackingEvents.introduction_completed, {
      type: "welcome_room",
    });
    setShowConfetti(true);
    setTimeout(() => {
      setShowConfetti(false);
      updateState();
    }, 3000);
  };
  console.log(doodleLink, "doodleLinkdoodleLink");
  return (
    <div
      className="welcome-room"
      style={bgUrl ? { backgroundImage: `url(${bgUrl})` } : undefined}
    >
      {/* Doodle canvas — white panel at the top */}
      {doodleLink && (
        <div className="welcome-room__canvas">
          <img
            src={doodleLink || welcomeSign}
            alt="Welcome doodle"
            className="welcome-room__doodle"
          />
        </div>
      )}

      {/* Chat bubble */}
      {currentObject?.content?.trim() && (
        <div className="welcome-room__bubble">
          <ChatBubble
            content={currentObject.content}
            textColor={currentObject.textColor}
            tailSide="right"
            audioUri={currentObject.audio}
          />
        </div>
      )}

      {/* Bottom action buttons */}
      {showButton && (
        <div className="welcome-room__actions">
          {firstBlock?.userActions
            ?.filter((a) => a.component === "block.button-input")
            .map((action, i) => (
              <button
                key={i}
                type="button"
                className={`welcome-room__btn${
                  action.buttonText?.toLowerCase() === "more confetti"
                    ? " welcome-room__btn--outline"
                    : " welcome-room__btn--filled"
                }`}
                onClick={handleButtonPress}
              >
                {action.buttonText}
              </button>
            ))}
        </div>
      )}

      {/* Confetti overlay */}
      {showConfetti && (
        <Lottie
          animationData={confettiJson}
          loop
          autoplay
          className="welcome-room__confetti"
        />
      )}
    </div>
  );
}

export default OnBoardingWelcomeRoom;
